var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGuideFilled = function SvgGuideFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M1.498 3.406c2.924-.79 7.505-.5 9.61 1.53a.28.28 0 0 1 .082.199v14.57c0 .24-.283.378-.483.24-2.75-1.889-6.55-2.404-9.285-1.348-.2.077-.422-.063-.422-.275V4.072c0-.309.197-.585.498-.666M22.502 3.406c-2.924-.79-7.505-.5-9.61 1.53a.28.28 0 0 0-.082.199v14.57c0 .24.283.378.483.24 2.75-1.889 6.55-2.404 9.285-1.348.2.077.422-.063.422-.275V4.072a.68.68 0 0 0-.498-.666"
  })));
};
export default SvgGuideFilled;